import React from "react";
import moment from "moment";
import { Grid, GridItem } from "@sainsburys-tech/fable";
import LastUpdate from "../LastUpdate";
import PropTypes from "prop-types";

const parseGatewayLastOnline = gatewayLastOnline => {
  return gatewayLastOnline > new Date() ? new Date() : gatewayLastOnline;
};

const StoreLightingStatusPanel = props => (
  <div>
    <Grid cols={{ sm: 5, default: 1 }}>
      <GridItem colSpan={1}>
        <span className="fable:font-bold fable:bg-gray-100 fable:p-2 cb-c-store-lighting-status-panel__header">
          Last gateway message
        </span>

        <div className="fable:p-2 cb-c-store-lighting-status-panel__row">
          Last updated{" "}
          <LastUpdate>
            {parseGatewayLastOnline(props.storeStatus.gatewayLastOnline)}
          </LastUpdate>
        </div>
      </GridItem>
      <GridItem colSpan={1}>
        <span className="fable:font-bold fable:bg-gray-100 fable:p-2 cb-c-store-lighting-status-panel__header">
          Store is
        </span>

        <div className="fable:p-2 cb-c-store-lighting-status-panel__row">
          {props.activeScene}
        </div>
      </GridItem>
      <GridItem colSpan={1}>
        <span className="fable:font-bold fable:bg-gray-100 fable:p-2 cb-c-store-lighting-status-panel__header">
          Last acknowledged schedule
        </span>

        <div className="fable:p-2 cb-c-store-lighting-status-panel__row">
          {moment(props.storeStatus.lastAcknowledgedSchedule).format(
            "HH:mm, DD/MM/YY"
          )}
        </div>
      </GridItem>
      <GridItem colSpan={1}>
        <span className="fable:font-bold fable:bg-gray-100 fable:p-2 cb-c-store-lighting-status-panel__header">
          Managers Override
        </span>

        <div className="fable:p-2 cb-c-store-lighting-status-panel__row">
          {props.storeStatus.managersOverrideEngaged ? "On" : "Off"}
        </div>
      </GridItem>
      <GridItem colSpan={1}>
        <span className="fable:font-bold fable:bg-gray-100 fable:p-2 cb-c-store-lighting-status-panel__header">
          Store commissioned
        </span>

        <div className="fable:p-2 cb-c-store-lighting-status-panel__row">
          {moment(props.storeStatus.lastCommissioned).format("DD/MM/YY")}
        </div>
      </GridItem>
    </Grid>
  </div>
);

StoreLightingStatusPanel.propTypes = {
  storeStatus: PropTypes.shape({
    commissioningStatus: PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string
    }),
    gatewayLastOnline: PropTypes.Date,
    gatewayOnline: PropTypes.bool,
    lastAcknowledgedSchedule: PropTypes.Date,
    lastCommissioned: PropTypes.Date,
    managersOverrideEngaged: PropTypes.bool
  }),
  activeScene: PropTypes.string
};
export default StoreLightingStatusPanel;
